var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeed05X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.45455,
    y: 6.81836,
    width: 19.0909,
    height: 16.3636,
    stroke: "#F4F4F4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.57741 10.9092C10.1989 10.9092 10.7013 11.2057 11.0849 11.7987C11.4684 12.3882 11.6602 13.4216 11.6602 14.8989C11.6602 16.3726 11.4684 17.406 11.0849 17.999C10.7013 18.5885 10.2006 18.8833 9.58274 18.8833C8.96129 18.8833 8.45881 18.5903 8.07528 18.0043C7.69176 17.4184 7.5 16.3779 7.5 14.8829C7.5 13.4163 7.69176 12.3882 8.07528 11.7987C8.45881 11.2057 8.95952 10.9092 9.57741 10.9092ZM9.57741 12.1503C9.33594 12.1503 9.1424 12.3101 8.9968 12.6297C8.85476 12.9493 8.78374 13.7057 8.78374 14.8989C8.78374 16.0921 8.85476 16.8485 8.9968 17.1681C9.1424 17.4841 9.33594 17.6421 9.57741 17.6421C9.82244 17.6421 10.016 17.4823 10.158 17.1627C10.3001 16.8431 10.3711 16.0885 10.3711 14.8989C10.3711 13.7057 10.3001 12.9493 10.158 12.6297C10.016 12.3101 9.82244 12.1503 9.57741 12.1503Z",
    fill: "#F4F4F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0869 18.7501V17.2533H13.3174V18.7501H12.0869Z",
    fill: "#F4F4F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6803 16.7419L14.9054 16.5874C14.9374 16.9284 15.0421 17.1965 15.2197 17.3918C15.3972 17.5871 15.5925 17.6847 15.8056 17.6847C16.0577 17.6847 16.2744 17.5605 16.4555 17.3119C16.6366 17.0597 16.7271 16.6744 16.7271 16.156C16.7271 15.6659 16.6366 15.3037 16.4555 15.0693C16.2779 14.835 16.0506 14.7178 15.7737 14.7178C15.4221 14.7178 15.106 14.9078 14.8255 15.2877L13.8294 15.1119L14.458 11.0477H17.7019V12.4486H15.3901L15.193 13.7749C15.47 13.608 15.7506 13.5246 16.0347 13.5246C16.5389 13.5246 16.9668 13.7235 17.3184 14.1212C17.7623 14.629 17.9842 15.2984 17.9842 16.1293C17.9842 16.8147 17.7942 17.445 17.4143 18.0203C17.0379 18.5956 16.4981 18.8833 15.795 18.8833C15.2268 18.8833 14.7509 18.6986 14.3674 18.3293C13.9874 17.9564 13.7584 17.4273 13.6803 16.7419Z",
    fill: "#F4F4F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6546 18.7501L19.3272 15.8364L17.7239 13.0931H19.226L20.0463 14.6485L20.9092 13.0931H22.3474L20.7761 15.7725L22.4966 18.7501H20.9891L20.0463 16.9976L19.0875 18.7501H17.6546Z",
    fill: "#F4F4F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeed05X);
export default __webpack_public_path__ + "static/media/speed05X.9254d9c6f545aab8f53db937eed78638.svg";
export { ForwardRef as ReactComponent };